import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseToolbarFeature from '../../../common/feature/base-toolbar-feature';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ImageReplaceAction } from '@src/slide/application/service/copy-paste/core/cp-image.new/image-edit-manager/core/image-edit-manager.interface';

@Feature()
export class ReplacePictureFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;

    public async replacePic(fromFile: boolean) {
        const module = await this.getCopyPasteImageService()?.promise();
        if (!module) return;
        const selectedModel = this.getSelectionService()?.getSelectedModel();
        const action = selectedModel?.type === UIModelType.MULTIPLY
            ? ImageReplaceAction.multi
            : selectedModel?.type === UIModelType.IMAGE
                ? ImageReplaceAction.foreground
                : ImageReplaceAction.background;
        const { ImageEditManager } = module;
        if (fromFile) {
            ImageEditManager.getInstance().replaceImageFromFile(action);
        } else {
            ImageEditManager.getInstance().replaceImageFromClipBoard(action);
        }
    }

    private getCopyPasteImageService() {
        return this.getAppService().editableServiceLayer?.copyPasteImageService;
    }
}
